module.exports = __webpack_public_path__ + "telegram.svg?c27695feb8601cd640b3ddffa106df19";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/SocialNetworks/telegram.svg
// module id = 76
// module chunks = 0